<template>
  <li
    data-sidebar="menu-item"
    class="group/menu-item relative list-none min-w-0"
  >
    <slot />
  </li>
</template>
